<div
  class="confirm-container d-flex flex-column align-items-center justify-content-center w-100"
  [class.caltex-confirm-mobile]="isCaltex"
>
  <img
    *ngIf="!isCaltex"
    class="cross-icon"
    src="assets/img/cross.png"
    [mat-dialog-close]
  />
  <div class="icon d-flex justify-content-center align-items-center mt-3">
    <img
      *ngIf="isCaltex"
      class="confirm-icon-caltex"
      src="assets/img/icon-question-mark.svg"
      alt="question-mark icon"
      aria-hidden="true"
    />
    <span
      *ngIf="!isCaltex"
      class="confirm-icon d-block"
      aria-hidden="true"
    ></span>
  </div>
  <div class="confirm-title mt-3" [ngClass]="{ 'text-center w-100': isCaltex }">
    {{ "common.receipt.confirmClaim" | translate }}
  </div>
  <div
    class="confirm-txt mt-2"
    [ngClass]="{
      'confirm-txt-caltex text-muted text-start w-100 align-self-stretch':
        isCaltex
    }"
    [innerHTML]="'common.receipt.confirmTxt' | translate"
  ></div>
  <hr class="w-100" />
  <button
    class="submit-btn"
    [class.w-100]="isCaltex"
    (click)="submit()"
    [mat-dialog-close]="submitClaim"
  >
    {{
      isCaltex
        ? ("common.receipt.confirmSubmit" | translate)
        : ("common.submit" | translate)
    }}
  </button>
  <button
    class="confirm-cancel-btn mt-2"
    [class.confirm-cancel-btn-caltex]="isCaltex"
    [class.w-100]="isCaltex"
    [class.px-4]="isCaltex"
    [class.py-3]="isCaltex"
    [mat-dialog-close]
  >
    {{
      isCaltex
        ? ("common.receipt.confirmBack" | translate)
        : ("common.back" | translate)
    }}
  </button>
</div>
